import type { SVGProps } from "react";

export const Zoho = (props: SVGProps<SVGSVGElement>) => (
  <svg
    id="Layer_1"
    style={{}}
    version="1.1"
    viewBox="0 0 512 512"
    x="0px"
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    y="0px"
    {...props}
  >
    <title>Zoho</title>

    <g>
      <g>
        <g>
          <path
            d="M228.6,320.9c-3.9,0-7.9-0.8-11.7-2.5l0,0l-81.1-36.2c-14.5-6.4-21-23.5-14.6-38l36.2-81.1
				c6.4-14.5,23.5-21,38-14.6l81.1,36.2c14.5,6.4,21,23.5,14.6,38L255,303.8C250.2,314.6,239.7,320.9,228.6,320.9z M223.7,303.2
				c6.1,2.7,13.3-0.1,16.1-6.1l36.2-81.1c2.7-6.1-0.1-13.3-6.1-16.1l-81.2-36.2c-6.1-2.7-13.3,0.1-16.1,6.1L136.4,251
				c-2.7,6.1,0.1,13.3,6.1,16.1L223.7,303.2z"
            style={{ fill: "#089949" }}
          />
        </g>
        <g>
          <path
            d="M483.2,321h-88.9c-15.9,0-28.8-12.9-28.8-28.8v-88.9c0-15.9,12.9-28.8,28.8-28.8h88.9
				c15.9,0,28.8,12.9,28.8,28.8v88.9C512,308,499.1,321,483.2,321z M394.3,191.1c-6.7,0-12.2,5.5-12.2,12.2v88.9
				c0,6.7,5.5,12.2,12.2,12.2h88.9c6.7,0,12.2-5.5,12.2-12.2v-88.9c0-6.7-5.5-12.2-12.2-12.2H394.3z"
            style={{ fill: "#F9B21D" }}
          />
        </g>
        <path
          d="M150.4,219.6l-12,26.8c-0.2,0.3-0.3,0.6-0.5,0.8l4.7,28.8c1.1,6.6-3.4,12.9-10,13.9l-87.7,14.2
			c-3.2,0.5-6.4-0.3-9.1-2.1c-2.6-1.9-4.4-4.7-4.9-7.9l-14.2-87.7c-0.5-3.2,0.3-6.4,2.1-9.1c1.9-2.6,4.7-4.4,7.9-4.9l87.7-14.2
			c0.7-0.1,1.3-0.2,1.9-0.2c5.8,0,11.1,4.3,12,10.2l4.7,29l12.4-27.7l-0.7-3.9c-2.5-15.7-17.3-26.4-33-23.8L24.2,176
			c-7.6,1.2-14.3,5.3-18.7,11.5c-4.5,6.2-6.3,13.8-5.1,21.5l14.2,87.7c1.2,7.6,5.3,14.3,11.6,18.8c4.9,3.6,10.8,5.4,16.8,5.4
			c1.5,0,3.1-0.1,4.7-0.4l87.7-14.2c15.7-2.5,26.4-17.3,23.8-33L150.4,219.6z"
          style={{ fill: "#E42527" }}
        />
        <g>
          <path
            d="M255.7,261.5l12.9-28.9l-3.7-26.8c-0.5-3.2,0.4-6.4,2.4-9c2-2.6,4.8-4.3,8.1-4.7l88-12
				c0.6-0.1,1.1-0.1,1.7-0.1c2.6,0,5.2,0.9,7.4,2.5c0.4,0.3,0.8,0.7,1.1,1c3.9-4.1,9-7,14.8-8.3c-1.6-2.2-3.6-4.2-5.8-5.9
				c-6.1-4.7-13.7-6.6-21.3-5.6l-88.1,12c-7.6,1-14.4,5-19,11.1c-4.7,6.1-6.6,13.7-5.6,21.3L255.7,261.5z"
            style={{ fill: "#226DB4" }}
          />
          <path
            d="M405.5,276.3l-11.6-85.2c-6.5,0.2-11.7,5.6-11.7,12.1v25l6.8,50.3c0.5,3.2-0.4,6.4-2.4,9
				c-2,2.6-4.8,4.3-8.1,4.7l-88,12c-3.2,0.5-6.4-0.4-9-2.4c-2.6-2-4.3-4.8-4.7-8.1l-4.1-29.9L260,292.7l0.5,3.2
				c1,7.6,5,14.4,11.1,19c5.1,3.9,11.1,5.9,17.4,5.9c1.3,0,2.6-0.1,4-0.3l87.9-11.9c7.6-1,14.4-5,19-11.1
				C404.5,291.5,406.5,283.9,405.5,276.3z"
            style={{ fill: "#226DB4" }}
          />
        </g>
      </g>
      <g>
        <path
          d="M157.1,363.1l12.6-18.6h-10.3c-0.6,0-1-0.5-1-1V341c0-0.6,0.5-1,1-1h17c0.6,0,1,0.5,1,1v1c0,0.2-0.1,0.4-0.2,0.6
			l-12.3,18.6h11.1c0.6,0,1,0.5,1,1v2.5c0,0.6-0.5,1-1,1h-18c-0.6,0-1-0.5-1-1v-0.9C156.9,363.5,157,363.3,157.1,363.1z"
        />
        <path
          d="M210,352.7c0-7.6,5.6-13.1,13.2-13.1c7.9,0,13.2,5.4,13.2,13.1c0,7.9-5.4,13.3-13.3,13.3C215.2,366,210,360.6,210,352.7z
			 M230.4,352.8c0-4.6-2.2-8.6-7.3-8.6c-5.1,0-7,4.1-7,8.8c0,4.4,2.4,8.5,7.3,8.5C228.4,361.4,230.4,357.1,230.4,352.8z"
        />
        <path
          d="M272.5,340h3.8c0.6,0,1,0.5,1,1v9.4h10.7V341c0-0.6,0.5-1,1-1h3.8c0.6,0,1,0.5,1,1v23.6c0,0.6-0.5,1-1,1h-3.7
			c-0.6,0-1-0.5-1-1V355h-10.7v9.5c0,0.6-0.5,1-1,1h-3.8c-0.6,0-1-0.5-1-1V341C271.5,340.4,271.9,340,272.5,340z"
        />
        <path
          d="M328.7,352.7c0-7.6,5.6-13.1,13.2-13.1c7.9,0,13.2,5.4,13.2,13.1c0,7.9-5.4,13.3-13.3,13.3
			C333.9,366,328.7,360.6,328.7,352.7z M349,352.8c0-4.6-2.2-8.6-7.3-8.6c-5.1,0-7,4.1-7,8.8c0,4.4,2.4,8.5,7.3,8.5
			C347,361.4,349,357.1,349,352.8z"
        />
      </g>
    </g>
  </svg>
);

export default Zoho;
